import { render, staticRenderFns } from "./admin-client-session-bar.vue?vue&type=template&id=409d3c82&scoped=true&"
import script from "./admin-client-session-bar.vue?vue&type=script&lang=ts&"
export * from "./admin-client-session-bar.vue?vue&type=script&lang=ts&"
import style0 from "./admin-client-session-bar.vue?vue&type=style&index=0&id=409d3c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409d3c82",
  null
  
)

export default component.exports